import { useEffect } from "react";

const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const useSEO = ({ title, description, url, type = "website", image }) => {
    useEffect(() => {
        if (title) document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("property", "og:type", type);
        setMeta("property", "og:site_name", "Investidor Comum");
        setMeta("property", "og:image", image);
        setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
    }, [title, description, url, type, image]);
};
